import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <g opacity="0.4">
      <path
        d="M19.1111 3.5C19.602 3.5 20 3.90878 20 4.41304V10.8043H4V4.41304C4 3.90878 4.39797 3.5 4.88889 3.5H19.1111Z"
        fill="#21201F"
      />
      <path
        d="M5.77778 12.6304H4V19.9348L10.1818 24.5H12V17.2131C12 16.546 11.6459 15.9319 11.0763 15.6115L5.77778 12.6304Z"
        fill="#21201F"
      />
    </g>
    <path d="M17.3329 6.23828H13.7773V8.06437H17.3329V6.23828Z" fill="#21201F" />
    <path
      d="M5.77734 12.6296H19.9996V19.0209C19.9996 19.5252 19.6016 19.9339 19.1107 19.9339H11.9996V17.2122C11.9996 16.5451 11.6454 15.9311 11.0758 15.6106L5.77734 12.6296Z"
      fill="#21201F"
    />
  </>,
  'Locker',
)
